<template>
<nav class="navbar is-primary" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <img 
      src="../assets/images/9ball.png" 
      width="60px" 
      height="auto" 
      style="margin: 10px 0px 10px 30px;" 
      class="is-hidden-mobile"
    />
    <img 
      src="../assets/images/9ball.png" 
      width="23%"
      height="10%" 
      style="margin: 10px 0px 10px 30px;" 
      class="is-hidden-tablet"
    />    
    <p class="header is-hidden-mobile" style="margin-top:10px;">Generalens Biljardklubb</p>
    <p class="header is-hidden-tablet" style="margin-top:15px;font-size:1.5rem;">Generalens Biljardklubb</p>


    <a role="button" class="navbar-burger burger" data-target="navMenu" aria-label="menu" aria-expanded="false">
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>

  <div class="navbar-menu" id="navMenu" role="navigation" aria-label="main navigation">
    <!-- FOR PC -->
    <div class="navbar-start is-hidden-mobile">
      <a class="navbar-item">
        <router-link to="/" class="has-text-white has-text-weight-bold" >Hjem</router-link>
      </a>
      <a class="navbar-item">
        <router-link to="/bord" class="has-text-white has-text-weight-bold">Bordbooking</router-link>
      </a>
      <a class="navbar-item">
        <router-link to="/admin" class="has-text-white has-text-weight-bold">Admin</router-link>
      </a>
    </div>
    <!-- FOR MOBIL -->
    <div class="navbar-start is-hidden-desktop">
      <a class="navbar-item">
        <router-link to="/" class="has-text-weight-bold" >Hjem</router-link>
      </a>
      <a class="navbar-item">
        <router-link to="/bord" class="has-text-weight-bold">Bordbooking</router-link>
      </a>
      <a class="navbar-item">
        <router-link to="/admin" class="has-text-weight-bold">Admin</router-link>
      </a>
    </div>    

    <div class="navbar-end is-hidden-mobile">
      <div class="navbar-item">
        <div class="buttons">
            <a class="button is-warning" href="https://www.facebook.com/groups/1006341226433510/">
                <strong>Facebook</strong>
            </a>
        </div>
      </div>
    </div>
  </div>
</nav>
</template>

<script>
export default {
  name: 'Nav',
  data() {
    return {
    }
  }, 
  methods: {
    // setPage(side){
    //   switch(side){
    //     case 'ranking':
    //       this.$store.state.home = false;
    //       this.$store.state.tournaments = false;
    //       this.$store.state.ranking = true;
    //       break;
    //     case 'home':
    //       this.$store.state.home = true;
    //       this.$store.state.tournaments = false;
    //       this.$store.state.ranking = false;  
    //       break;
    //     case 'tournament':
    //       this.$store.state.home = false;
    //       this.$store.state.tournaments = true;
    //       this.$store.state.ranking = false; 
    //       break;         
    //   }
    // }
  }
}

// Burger
document.addEventListener('DOMContentLoaded', () => {

  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach( el => {
      el.addEventListener('click', () => {

        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

});
</script>

